import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';
export default function CustomTooltip({
  element,
  customContent,
  open
}: {
  element: React.ReactNode;
  customContent: React.ReactNode;
  open: boolean;
}) {
  return (
    <TooltipProvider>
      <Tooltip open={open}>
        <TooltipTrigger asChild>{element}</TooltipTrigger>
        <TooltipContent
          sideOffset={50}
          alignOffset={0}
          className="custome-tooltip overflow-visible bg-white p-0"
        >
          {customContent}{' '}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
